<script>
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from 'svelte';
    import { updateUrlParam } from '../base/url.js';

    export let pages = 1;
    export let currentPage = 1;
    let renderedPages = [];


    const dispatch = createEventDispatcher();

    // Dispatch 'next' event
    function handleNext() {
        if (currentPage < pages) {
            currentPage += 1;
            dispatch('next', { currentPage });
        }
    }

    // Dispatch 'previous' event
    function handlePrevious() {
        if (currentPage > 1) {
            currentPage -= 1; 
            dispatch('previous', { currentPage });
        }
    }

    // Change page on click
    function goToPage(page) {
        currentPage = page;
        dispatch('previous', { currentPage });
    }

    $: {
        currentPage = parseInt(currentPage);
        pages = parseInt(pages);     
        renderedPages = [];
        let startPage = parseInt(Math.max(1, currentPage - 5)); // Start 5 pages before current page
        let endPage = parseInt(Math.min(pages, currentPage + 4)); // End 4 pages after current page

        //console.log('pagination page1 ' , currentPage , pages,startPage , endPage)


        // Adjust to ensure 10 pages are shown when possible
        if (endPage - startPage < 9) {
            if (startPage === 1) {
                endPage = parseInt(Math.min(pages, parseInt(startPage) + 9));
            } else if (endPage === pages) {
                startPage = parseInt(Math.max(1, parseInt(endPage) - 9));
            }
        }

        //console.log('pagination page2 ' , currentPage ,pages,startPage , endPage)

        // Push the page numbers to renderedPages array
        for (let i = startPage; i <= endPage; i++) {
            renderedPages.push(i);
        }
    }
    
</script>

<style>
    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-top: 10px;
        font-size: 12px;;
    }

    .page-item {
        padding: 5px 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        user-select: none;
    }

    .active {
        background-color: #007bff;
        color: white;
    }

    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    button {
        padding: 5px 10px;
        cursor: pointer;
    }
</style>

<div class="pagination">

    <button on:click={() => goToPage(1)}>
        {$_('pagination.first')}
    </button>

    <button on:click={handlePrevious} class:disabled={currentPage <= 1}>{$_('pagination.previous')}</button>

    {#each renderedPages as page}
        <div 
            class="page-item {currentPage === page ? 'active' : ''}" 
            on:click={() => goToPage(page)}>
            {page}
        </div>
    {/each}

    <button on:click={handleNext} class:disabled={currentPage >= pages}>{$_('pagination.next')}</button>

    <button on:click={() => goToPage(pages)}>
        {$_('pagination.last')}
    </button>
</div>
